var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"loader-spinner",attrs:{"alt":"PayFast Loader","src":_vm.Loader}}),_c('div',{staticClass:"loading-desription"},[_vm._v(" "+_vm._s(_vm.instruction ? _vm.instruction : 'Loading...')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }